import { setUserId, load, DEV, PROD } from '@seek/hirer-sift-wrapper';

import { createAuthService } from 'src/app/authService/authService';
import { isProd, isDev } from 'src/app/utils/environment';
import globals from 'src/app/utils/globals';

import { log } from '../logging';

const loadSift = async (): Promise<void> => {
  if (!globals.window.isImpersonating && !isDev()) {
    const { getUserIdentity } = createAuthService();
    const userInfo = await getUserIdentity();
    if (!userInfo) {
      log.error('loadSift | no user data returned from getUserInfo');
      return;
    }

    try {
      setUserId(userInfo.ID);
      load(isProd() ? PROD : DEV);
    } catch (error) {
      log.error('loadSift | Error', { error });
    }
  }
};

export default loadSift;
